const apiKey = 'de2b0044146e31a72e204fc70e7c675a';
export default apiKey;